/**
* File and all contents are proprietary work of Executives On The Web Ltd
* and must not be copied or redistributed without express permission.
*
* a provides a means of converting file extensions to mime types
*
* @since 20200604
* @author Thomas Higham <thomash@executivesontheweb.com>
*
* @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
*/
export default {
    getMimeType: function(extension){
        if(extension.substr(0,1) == '.'){
            extension = extension.substr(1,extension.length-1);
        }
        if(extension == 'pdf'){
            return {
                type: "pdf",
                mimeType: "application/pdf",
                name: "PDF"
            }
        }
        else if(extension == 'docx'){
            return {
                type: "docx",
                mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                name: "Microsoft Word"
              }
        }

        else if(extension == 'doc'){
            return {
                type: "doc",
                mimeType: "application/msword",
                name: "Microsoft Word",
              }
        }

        else if(extension == 'pptx'){
            return {
                type: "pptx",
                mimeType: ".pptx",
                name: "Microsoft Publisher",
              }
        }

        else if(extension == 'ppt'){
            return {
                type: "ppt",
                mimeType: ".ppt",
                name: "Microsoft Publisher",
              }
        }

        else if(extension == 'pub'){
            return {
                type: "pub",
                mimeType: "application/x-mspublisher",
                name: "Microsoft Publisher",
              }
        }

        else if(extension == 'xlsx'){
            return {
                type: "xlsx",
                mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                name: "Microsoft Excel Spreadsheet",
              }
        }

        else if(extension == 'xls'){
            return {
                type: "xls",
                mimeType: "application/vnd.ms-excel",
                name: "Microsoft Excel Spreadsheet",
              }
        }

        else if(extension == 'csv'){
            return {
                type: "csv",
                mimeType: "text/csv",
                name: "Comma Separated Variable",
              }
        }

        else if(extension == 'oth'){
            return {
                type: "oth",
                mimeType: "application/vnd.oasis.opendocument.text-web",
                name: "OpenDocument",
              }
        }

        else if(extension == 'ods'){
            return {
                type: "ods",
                mimeType: "application/vnd.oasis.opendocument.spreadsheet",
                name: "OpenDocument Spreadsheet",
              }
        }

        else if(extension == 'rtf'){
            return {
                type: "rtf",
                mimeType: "application/rtf",
                name: "Rich Text Format",
              }
        }

        else if(extension == 'txt'){
            return {
                type: "txt",
                mimeType: "text/plain",
                name: "Text File",
              }
        }

        else if(extension == 'html'){
            return {
                type: "html",
                mimeType: "text/html",
                name: "HTML",
              }
        }

        else if(extension == 'jpg'){
            return {
                type: "jpg",
                mimeType: "image/jpeg",
                name: "jpeg image",
              }
        }

        else if(extension == 'jpeg'){
            return {
                type: "jpeg",
                mimeType: "image/jpeg",
                name: "jpeg image",
              }
        }

        else if(extension == 'png'){
            return {
                type: "png",
                mimeType: "image/png",
                name: "png image",
              }
        }

        else if(extension == 'gif'){
            return {
                type: "gif",
                mimeType: "image/gif",
                name: "gif image",
              }
        }

        else if(extension == 'wav'){
            return {
                type: "wav",
                mimeType: "audio/wav",
                name: "wav Audio",
              }
        }

        else if(extension == 'mp3'){
            return {
                type: "mp3",
                mimeType: "audio/mpeg",
                name: "MPEG-3 Audio",
              }
        }

        else if(extension == 'mp4'){
            return {
                type: "mp4",
                mimeType: "video/mp4",
                name: "MPEG-4 Video",
              }
        }

        else if(extension == 'm4v'){
            return {
                type: "m4v",
                mimeType: "video/mp4",
                name: "MPEG-4 Video",
              }
        }

        else if(extension == 'wmv'){
            return {
                type: "wmv",
                mimeType: "video/x-ms-wmv",
                name: "Windows Media Video",
              }
        }

        else if(extension == 'avi'){
            return {
                type: "avi",
                mimeType: "video/x-msvideo",
                name: "A/V Interleave Video",
              }
        }

        else if(extension == 'mov'){
            return {
                type: "mov",
                mimeType: "video/quicktime",
                name: "QuickTime Video",
              }
        }

        else if(extension == '3gp'){
            return {
                type: "3gp",
                mimeType: "video/3gpp",
                name: "3GP Mobile Video",
              }
        }

        else if(extension == 'webm'){
            return {
                type: "webm",
                mimeType: ".webm",
                name: "WebM Video",
              }
        }

        else if(extension == 'zip'){
            return {
                type: "zip",
                mimeType: "application/zip",
                name: "Zip Folder",
              }
        }

        else if(extension == 'uasset'){
            return {
                type: "uasset",
                mimeType: "application/octet-stream",
                name: "Unreal Engine Asset",
              }
        }

        else if(extension == 'application/vnd.google-apps.document'){
            return {
                type: "application/vnd.google-apps.document",
                mimeType: "application/vnd.google-apps.document",
                name: "Google Document",
              }
        }

        else if(extension == 'application/vnd.google-apps.audio'){
            return {
                type: "application/vnd.google-apps.audio",
                mimeType: "application/vnd.google-apps.audio",
                name: "Google Audio",
              }
        }

        else if(extension == 'application/vnd.google-apps.drawing'){
            return {
                type: "application/vnd.google-apps.drawing",
                mimeType: "application/vnd.google-apps.drawing",
                name: "Google Drawing",
              }
        }

        else if(extension == 'application/vnd.google-apps.file'){
            return {
                type: "application/vnd.google-apps.file",
                mimeType: "application/vnd.google-apps.file",
                name: "Google File",
              }
        }

        else if(extension == 'application/vnd.google-apps.form'){
            return {
                type: "application/vnd.google-apps.form",
                mimeType: "application/vnd.google-apps.form",
                name: "Google Form",
              }
        }

        else if(extension == 'application/vnd.google-apps.fusiontable'){
            return {
                type: "application/vnd.google-apps.fusiontable",
                mimeType: "application/vnd.google-apps.fusiontable",
                name: "Google Fushion Table",
              }
        }

        else if(extension == 'application/vnd.google-apps.photo'){
            return {
                type: "application/vnd.google-apps.photo",
                mimeType: "application/vnd.google-apps.photo",
                name: "Google Photo",
              }
        }

        else if(extension == 'application/vnd.google-apps.presentation'){
            return {
                type: "application/vnd.google-apps.presentation",
                mimeType: "application/vnd.google-apps.presentation",
                name: "Google Presentation",
              }
        }

        else if(extension == 'application/vnd.google-apps.sites'){
            return {
                type: "application/vnd.google-apps.sites",
                mimeType: "application/vnd.google-apps.sites",
                name: "Google Site",
              }
        }

        else if(extension == 'application/vnd.google-apps.spreadsheet'){
            return {
                type: "application/vnd.google-apps.spreadsheet",
                mimeType: "application/vnd.google-apps.spreadsheet",
                name: "Google Spreadsheet",
              }
        }

        else if(extension == 'application/vnd.google-apps.video'){
            return {
                type: "application/vnd.google-apps.video",
                mimeType: "application/vnd.google-apps.video",
                name: "Google Video",
              }
        }

        else if(extension == 'application/vnd.google-apps.script'){
            return {
                type: "application/vnd.google-apps.script",
                mimeType: "application/vnd.google-apps.script",
                name: "Google Script",
              }
        }

        else if(extension == 'folder'){
            return {
                type: "folder",
                mimeType: "application/vnd.google-apps.folder",
                name: "Folder",
            }
        }

        else if(extension == 'unknown'){
            return {
                type: "unknown",
                mimeType: "picker.unknown",
                name: "Unknown",
              }
        }

        else if(extension == 'nothing'){
            return {
                type: "nothing",
                mimeType: "picker.nothing",
                name: "No valid files in this folder!",
            }
        }

        else if(extension == 'All'){
            return {
                type: "All",
                mimeType: "",
                name: "Any File is Valid!",
            }
        }

        else {
            return {
                type: "",
                mimeType: "",
                name: "",
            }
        }
    }
}